var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import { FIRE_ELECTRICAL_BOARD_AGE_OPTIONS } from '@shared/constants/fireDamageConstants';
import { YES_OR_NO_CHOICES } from '@declaration/helpers/choices';
import { FireFireplaceWhoMakesWorks, FireWhoMakesWorks, } from '@shared/types/api/claim';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import ThirdPartyModal from '@declaration/components/thirdParty/ThirdPartyModal.vue';
const claim = namespace('claim');
const qualification = namespace('qualification');
const contract = namespace('contract');
const thirdParty = namespace('thirdParty');
const pages = namespace('pages');
let FireThirdPartyListQuestion = class FireThirdPartyListQuestion extends QuestionComponent {
    constructor() {
        super(...arguments);
        this.YES_OR_NO_CHOICES = YES_OR_NO_CHOICES;
        this.isModalOpen = false;
        this.invoiceFileCollection = null;
    }
    created() {
        this.invoiceFileCollection = this.fireDamageQualification.worksInvoiceCollection;
    }
    get thirdPartyPayload() {
        return {
            step: this.step,
            fireDamageQualification: {
                id: this.fireDamageQualification.id,
                hasProfessionalInfo: this.selectedValue,
                worksInvoiceCollection: this.invoiceFileCollection,
            },
        };
    }
    get getTitle() {
        if (this.fireDamageQualification.fireFireplaceWhoMakesWorks ===
            FireFireplaceWhoMakesWorks.professional ||
            this.fireDamageQualification.fireWhoMakesWorks === FireWhoMakesWorks.professional) {
            return this.$tc('claim.qualification.fire_third_party.title.pro');
        }
        else if (this.previousStep === 'qualification/incendie/age-compteur-electrique' ||
            this.previousStep === 'qualification/incendie/age-reseau-electrique') {
            return this.$tc('claim.qualification.fire_third_party.title.installateur');
        }
        else if (this.previousStep === 'declaration/feu/depot-de-plainte') {
            return this.$tc('claim.qualification.fire_third_party_crim_act.title');
        }
        else {
            return this.$tc('claim.qualification.fire_third_party.title.particular');
        }
    }
    get formTitleModal() {
        if (this.previousStep === 'declaration/feu/depot-de-plainte') {
            return this.$tc('claim.qualification.fire_third_party_crim_act.subform_title');
        }
        else {
            return this.$tc('claim.qualification.third_party_pro_info.subform_title');
        }
    }
    get selectedValue() {
        return this.fireDamageQualification.hasProfessionalInfo;
    }
    handleButtonClick(hasProfessionalInfo) {
        if (hasProfessionalInfo === false) {
            this.updateAndSaveQualification({
                qualificationPayload: { hasProfessionalInfo },
                step: this.step,
            });
        }
        else {
            if (this.thirdParties.length === 0)
                this.addNewThirdPartyAndEditIt(false);
            else
                this.setThirdPartyInEditionIndex(0);
            this.updateQualification({
                qualificationPayload: {
                    hasProfessionalInfo,
                },
            });
            this.isModalOpen = true;
        }
    }
    fileCollectionUpdate(event) {
        this.invoiceFileCollection = event;
    }
    get fireElectricalBoardAgeOptions() {
        return Object.values(FIRE_ELECTRICAL_BOARD_AGE_OPTIONS);
    }
    get answer() {
        var _a;
        if (this.fireDamageQualification.hasProfessionalInfo === null)
            return null;
        if (this.fireDamageQualification.hasProfessionalInfo === false || !this.thirdParties.length) {
            return this.$tc('claim.damage.glass_breakage.answer.room_damages_origin_third_party_known.no');
        }
        const [thirdParty] = this.thirdParties;
        const name = (_a = thirdParty.contact.companyName) !== null && _a !== void 0 ? _a : [thirdParty.contact.firstName, thirdParty.contact.lastName].filter(Boolean).join(' ');
        const address = [
            thirdParty.contact.address,
            [thirdParty.contact.zipcode, thirdParty.contact.city].filter(Boolean).join(' '),
            thirdParty.contact.addressAffix,
        ]
            .filter(Boolean)
            .join('<br/>');
        return this.$t('claim.damage.glass_breakage.answer.room_damages_origin_third_party_known.yes', {
            name,
            address,
        }).toString();
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], FireThirdPartyListQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    pages.Getter('previousStep')
], FireThirdPartyListQuestion.prototype, "previousStep", void 0);
__decorate([
    qualification.State('qualification')
], FireThirdPartyListQuestion.prototype, "fireDamageQualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], FireThirdPartyListQuestion.prototype, "updateAndSaveQualification", void 0);
__decorate([
    qualification.Action('updateQualification')
], FireThirdPartyListQuestion.prototype, "updateQualification", void 0);
__decorate([
    contract.State('selectedContract')
], FireThirdPartyListQuestion.prototype, "selectedContract", void 0);
__decorate([
    thirdParty.Action('addNewThirdPartyAndEditIt')
], FireThirdPartyListQuestion.prototype, "addNewThirdPartyAndEditIt", void 0);
__decorate([
    thirdParty.Action('setThirdPartyInEditionIndex')
], FireThirdPartyListQuestion.prototype, "setThirdPartyInEditionIndex", void 0);
__decorate([
    thirdParty.State('thirdParties')
], FireThirdPartyListQuestion.prototype, "thirdParties", void 0);
FireThirdPartyListQuestion = __decorate([
    Component({
        components: { RadioPrimaryButton, QuestionPanel, ThirdPartyModal },
        props: QuestionProps,
    })
], FireThirdPartyListQuestion);
export default FireThirdPartyListQuestion;
